import { useParams } from '@fs/zion-router'
import { type PID } from '@fs/zion-tree-types'
import { pidRegexStr } from '@fs/zion-pid'
import { type PathParamMap } from '../utils/pathParamTypes'

export const SPLIT_ANALYSIS_ROUTE_PATH =
  `/changelog/split-analysis/:combinedPid(${pidRegexStr as PID})/:extractedPid(${pidRegexStr as PID})` as const

type SplitAnalysisParams = PathParamMap<typeof SPLIT_ANALYSIS_ROUTE_PATH>

export function useSplitAnalysisParams(): SplitAnalysisParams {
  return useParams<SplitAnalysisParams>()
}
